import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, RewardData } from './types'

export const selectRewardListEvent = (state: RootState): Event => state.memberRewardReducer.listEvent

export const selectRewardList = (state: RootState): ListData => state.memberRewardReducer.list

export const selectRewardActionEvent = (state: RootState): Event => state.memberRewardReducer.actionEvent

export const selectRewardDetail = (state: RootState): RewardData | undefined =>
  state.memberRewardReducer.detail

export const selectRewardDetailEvent = (state: RootState): Event => state.memberRewardReducer.detailEvent
